module.exports = __webpack_public_path__ + "img/vip_new.98e1b48f.png";